export const PERCENT_TRACKING_BRAND = 70;
export const EXTRA_COST_BSI = 0; // prevValue: 8000000

export const BRAND_LEVEL = {
  level0: {
    key: 'level0',
    value: 'Level 0',
  },
  level1: {
    key: 'level1',
    value: 'Level 1',
  },
  level2: {
    key: 'level2',
    value: 'Level 2',
  },
  level3: {
    key: 'level3',
    value: 'Level 3',
  }
};

export const CAMPAIGN_LEVEL = {
  level1: {
    key: 'level1',
    value: 'Level 1',
  },
  level2: {
    key: 'level2',
    value: 'Level 2',
  },
  level3: {
    key: 'level3',
    value: 'Level 3',
  }
};
